import React from 'react';
import { useState, useEffect,useCallback } from 'react';
import { Grid,Container,Button} from '@mui/material';
import Copyright from '../Copyright';
import Panel from '../orderStatus/components/whitePanel';
import SelectSearchTypeOptions from './SelectSearchTypeOptions';
import styles from '../newOrder/components/DeliveryTime/pickUpDeliveryTime/styles.js';
import SearchIcon from '@mui/icons-material/Search';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import moment from 'moment';

import HistoryOrdersList from './HistoryOrderList.js';
import httpRequest from '../HttpService';
import { getStatusString, getLocationString } from '../newOrder/components/helperFunctions/index.js';
import { useUserContext} from "../lib/user_context";

export default function OrderHistory(props)  {
    const { sessionAccount} = useUserContext();
    const [orders, setOrders] = useState([]);
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [searchMonth, setSearchMonth] = useState(new Date());
    const [searchType, setSearchType] = useState('month');


    const [account, setAccount] = useState(sessionAccount);

    const getOrderList = useCallback(async (sessionAccount) => {
        try {
            const searchType = localStorage.getItem('searchHistory');
            if(searchType === null || searchType === "no") return;
            setSearchType(searchType);
            var search ={}
            if(searchType === 'month'){
                search.monthDate = localStorage.getItem('monthDate');
                setSearchMonth(localStorage.getItem('monthDate'));
            }
            if(searchType === 'date'){
                search.startDate = localStorage.getItem('startDate');
                search.endDate = localStorage.getItem('endDate');
                setStartDate(localStorage.getItem('startDate'));
                setEndDate(localStorage.getItem('endDate'));
            }
            if(sessionAccount!== null){
                httpRequest.orderSearch(sessionAccount, search).then(async (body) =>{
                    console.log("orderSearch return-" + JSON.stringify(body.data));
                    let orderList =  body.data.map((value,index) => {
                        value.id = index;
                        value.statusStr = getStatusString(value.Status);
                        value.locationStr = getLocationString(value.location);
                        value.dtCallIn_UTC = value.dtCallIn_UTC ? moment(value.dtCallIn_UTC).format('YYYY-MM-DD HH:mm') : null;
                        value.dtDCT_UTC = value.dtDCT_UTC ? moment(value.dtDCT_UTC).format('YYYY-MM-DD HH:mm') : null;
                        value.dtDelivered_UTC = value.dtDelivered_UTC ? moment(value.dtDelivered_UTC).format('YYYY-MM-DD HH:mm') : null;
                        return value;
                    });
                    setOrders(orderList);
                });
            }
        } catch (error) {
          console.log(error);
        }
      }, []);



    useEffect(() => {
        console.log("sessionAccount-" + localStorage.getItem('searchHistory'));
        setAccount(sessionAccount);
        getOrderList(sessionAccount);

        const style = document.createElement('style');
        style.id = 'tidio-history-style';
        style.innerHTML = `
            #tidio-chat-iframe {
                left: 50% !important;
                transform: translateX(-50%) !important;
                right: auto !important;
            }
        `;
        document.head.appendChild(style);

        return () => {
            const styleElement = document.getElementById('tidio-history-style');
            if (styleElement) {
                document.head.removeChild(styleElement);
            }
        };
    },[sessionAccount]);



    const handleSearch = () => {
        localStorage.setItem('searchHistory', searchType);
        const orderList=[];
        var search ={};
        if(searchType === "month"){
            //search.monthDate = moment(searchMonth).unix();
            search.monthDate =searchMonth;
            localStorage.setItem('monthDate', searchMonth);
           // moment(queryParams.endDate).unix();
        }
        else{
            //search.startDate = moment(startDate).unix();
            //search.endDate = moment(endDate).unix();
            search.startDate = startDate;
            search.endDate = endDate;
            localStorage.setItem('startDate', startDate);
            localStorage.setItem('endDate',endDate);
        }
        console.log( "handleSearch is " + JSON.stringify(search));
        console.log("orderSearch account-" +account);
        httpRequest.orderSearch(account, search).then(async (body) =>{
            console.log("orderSearch return-" + JSON.stringify(body.data));
            let orderList =  body.data.map((value,index) => {
                value.id = index;
                value.statusStr = getStatusString(value.Status);
                value.locationStr = getLocationString(value.location);
                value.dtCallIn_UTC = value.dtCallIn_UTC ? moment(value.dtCallIn_UTC).format('YYYY-MM-DD HH:mm') : null;
                value.dtDCT_UTC = value.dtDCT_UTC ? moment(value.dtDCT_UTC).format('YYYY-MM-DD HH:mm') : null;
                value.dtDelivered_UTC = value.dtDelivered_UTC ? moment(value.dtDelivered_UTC).format('YYYY-MM-DD HH:mm') : null;
                return value;
            });
            setOrders(orderList);
        });
    };

        return (
            <Container maxWidth="false" style={{ display: 'flex', flexDirection: 'column', height: 'calc(100vh - var(--header-height, 64px))' }}>
                <Panel>
                    <Grid container>
                        <Grid item md={2}>
                           <SelectSearchTypeOptions  onChange={(event)=>{setSearchType(event.target.value)}} name="searchType"/>
                        </Grid>
                         <Grid item md={2}>
                           <div  className="animate__animated animate__fadeInUp">
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <Grid container justifyContent="left">
                                    {searchType==='month' && <DatePicker
                                            size="small"
                                            value={searchMonth ? dayjs(searchMonth) : null}
                                            onChange={(date) => {
                                                console.log("month date is " + date);
                                                setSearchMonth(date ? date.toDate() : null);
                                            }}
                                            openTo="year"
                                            views={["year", "month"]}
                                            format="YYYY-MM"
                                            slotProps={{ textField: { size: 'small', style: styles.dateTimePicker } }}
                                        />}

                                        {searchType==='date' && <DatePicker
                                            size="small"
                                            value={startDate ? dayjs(startDate) : null}
                                            onChange={(date) => {
                                                console.log("start date is " + date);
                                                setStartDate(date ? date.toDate() : null);
                                            }}
                                            format="YYYY-MM-DD"
                                            slotProps={{ textField: { size: 'small', style: styles.dateTimePicker } }}
                                        />}
                                    </Grid>
                                </LocalizationProvider>
                            </div>
                        </Grid>
                        <Grid item md={2}>
                               {searchType==='date' && <div  className="animate__animated animate__fadeInUp">
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <Grid container justifyContent="left">
                                        <DatePicker
                                            size="small"
                                            value={endDate ? dayjs(endDate) : null}
                                            onChange={(date) => {
                                                console.log("end date is " + (date ? moment(date.toDate()).unix() : null));
                                                setEndDate(date ? date.toDate() : null);
                                            }}
                                            format="YYYY-MM-DD"
                                            slotProps={{ textField: { size: 'small', style: styles.dateTimePicker } }}
                                        />
                                    </Grid>
                                </LocalizationProvider>
                            </div>  }
                        </Grid>
                        <Grid item md={6}>
                            <Button
                               style={{maxWidth:"250px", minWidth:"200px", float:"right"}}
                               variant="contained"
                               color="primary"
                               startIcon={<SearchIcon style={{verticalAlign: 'middle', transform: 'scale(1.5)'}}/>}
                               onClick={handleSearch}
                            >
                            Search
                            </Button>
                        </Grid>
                    </Grid>
                </Panel>
                {orders.length>0 &&
                    <div className='container_history-list' style={{ flex: 1, minHeight: 0, height: 'auto' }}>
                      <HistoryOrdersList orders={orders} account={account}/>
                    </div>
                }
                 {props.isEmbedded!==null && props.isEmbedded!=="yes" && <footer><Copyright/></footer>}
            </Container>
            // </div>
        );

}